import RefreshIcon from "@mui/icons-material/Refresh";
import { Box, Button, Typography } from "@mui/material";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import useAPI from "../../../../api/hooks/useAPI";
import useColors from "../../../../api/hooks/useColors";
import { AzureKeys } from "../../../../api/queryKeys";
import LoadingIcon from "../../../../components/LoadingIcon";
import StyledDataGrid from "../../../../components/StyledDataGrid";

function AzureSubscriptionsTable() {
  const { getMicrosoftAzureCloudSubscriptions, trackEvent } = useAPI();
  const { data: subscriptions, isLoading: loadingSubscriptions } = useQuery({
    queryKey: AzureKeys.subscriptions(),
    queryFn: getMicrosoftAzureCloudSubscriptions,
    select: (data) => data.data,
  });
  const queryClient = useQueryClient();
  const colors = useColors();

  function onClick() {
    trackEvent("User clicked on refresh azure");
    queryClient.invalidateQueries({ queryKey: AzureKeys.subscriptions() });
  }

  const columns = [
    {
      field: "display_name",
      headerName: "Subscription Name",
      headerAlign: "left",
      flex: 1,
      resizable: false,
      disableReorder: true,
      renderCell: (params) => {
        return (
          <Box display="flex" alignItems="center" flexWrap="wrap" gap={1}>
            <Typography variant="body2" sx={{ flexGrow: 1 }}>
              {params.value}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "id",
      headerName: "Subscription ID",
      headerAlign: "left",
      flex: 1,
      resizable: false,
      disableReorder: true,
      renderCell: (params) => {
        return <Typography variant="body2">{params.value}</Typography>;
      },
    },
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="h4" gutterBottom>
          Integrated Subscriptions
        </Typography>
        <Button
          sx={{
            color: colors.text_primary,
            height: "30px",
            border: "1px solid " + colors.grey_light,
            textTransform: "unset",
            borderRadius: "8px",
            cursor: "pointer",
          }}
          startIcon={<RefreshIcon />}
          onClick={onClick}
        >
          Refresh
        </Button>
      </Box>
      {loadingSubscriptions ? (
        <LoadingIcon size={25} />
      ) : subscriptions && subscriptions.length > 0 ? (
        <StyledDataGrid
          style={{
            cursor: "pointer",
            "& .MuiDataGrid-cell:first-of-type, & .MuiDataGrid-columnHeader:first-of-type":
              {
                paddingLeft: "16px",
              },
            "& .MuiDataGrid-cell:last-of-type, & .MuiDataGrid-columnHeader:last-of-type":
              {
                paddingRight: "16px",
              },
          }}
          columns={columns}
          rows={subscriptions}
          isLoading={loadingSubscriptions}
        />
      ) : (
        <Typography variant="h6">
          No subscriptions found.
          <br /> Please make sure you have the required permissions to access
          your Azure subscriptions.
        </Typography>
      )}
    </Box>
  );
}

const MicrosoftAzureCloudConfigPage = ({}) => {
  return <AzureSubscriptionsTable />;
};

export default MicrosoftAzureCloudConfigPage;
